import styled from "styled-components";

export const Header = styled.div`
  h1 {
    color: var(--font-color-blue002e5c);
    font-size: var(--general-header-font-size);
    font-weight: var(--general-header-font-weight);
  }
  span {
    font-size: var(--general-sub-header-font-size);
    color: var(--font-color-grayb5b5c3);
  }
`;
export const Wrapper = styled.div``;
export const CheckBoxWrapper = styled.ul`
  list-style-type: none;
  li {
    font-size: var(--general-large-body-font-size);
    color: var(--font-color-blue002e5c);
  }
`;

export const CreditCardMethodContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;
export const CreditCardMethodHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  @media only screen and (max-width: 380px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const CreditCardMethodTitle = styled.div`
  color: var(--font-color-slate3f4255);
  font-size: var(--general-sub-header-font-size);
  font-weight: var(--general-sub-header-font-weight);
`;

export const CreditCardMethodContent = styled.div``;

export const CreditCardMethodList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const CreditCardMethodButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
`;

export const CreditCardMethodItem = styled.div`
  display: flex;
  gap: 15px;
  font-size: var(--general-body-font-size);
  flex-wrap: wrap;
  flex-direction: ${(props) =>
    props.bottomAdd && props.isSmallScreen ? "column" : "row"};
  align-items: ${(props) =>
    props.bottomAdd && props.isSmallScreen ? "baseline" : "center"};
  p {
    display: flex;
    gap: 14px;
    align-items: center;
    font-size: var(--general-body-font-size);
    margin: 0 !important;
    white-space: nowrap;
  }

  span > div,
  span label {
    margin: 0 !important;
  }
`;

export const CreditCardMethodItemVerify = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const CreditCardMethodItemVerifyInput = styled.input`
  width: 40px;
  height: 32px;
  border: 0.9px solid gray;
  text-align: center;
  border-radius: 5px;
`;

export const SMVerifyInput = styled.input`
  width: 120px;
  height: 32px;
  border: 0.9px solid gray;
  text-align: center;
  border-radius: 5px;
`;

export const VerifyAchCardOlList = styled.ol``;

export const VerifyAchCardOlItem = styled.li`
  font-size: var(--general-large-body-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-large-body-font-weight);
  width: 90%;
`;